import queryString from 'query-string'

export const eatSearchCookies = (search: string): string => {
  const filteredParams = Object.fromEntries(
    Object.entries(queryString.parse(search)).filter(
      ([k]) => !k.startsWith('__')
    )
  )

  return Object.keys(filteredParams).length > 0
    ? `?${queryString.stringify(filteredParams)}`
    : ''
}

export const eatUrlCookies = (url: string): string =>
  queryString.exclude(url, (name) => name.startsWith('__'))
